export const CREATE_MATERIEL = "CREATE_MATERIEL";
export const RETRIEVE_MATERIELS = "RETRIEVE_MATERIELS";
export const UPDATE_MATERIEL = "UPDATE_MATERIEL";
export const DELETE_MATERIEL = "DELETE_MATERIEL";
export const DELETE_ALL_MATERIELS = "DELETE_ALL_MATERIELS";
